import { ApartmentDto } from "@/api/models/coverage.model";
import { apartmentInitialState } from "./apartment";

const setApartment = (state: any, apartment: ApartmentDto) => {
	state.apartment = apartment;
};

const clearApartment = (state: any) => {
	Object.assign(state, apartmentInitialState());
};

export default {
	setApartment,
	clearApartment
};
